export default __webpack_public_path__ + "static/media/hunt.75b49d01.png";